import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  CircularProgress,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import socket from '../../services/socket-io';

import TicketHeader from '../TicketHeader';
import TicketInfo from '../TicketInfo';
import MessagesList from '../MessagesList';
import TagSelect from '../TagSelect';
import { ReplyMessageProvider } from '../../context/ReplyingMessage/ReplyingMessageContext';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    height: '90vh',
    maxHeight: '90vh',
  },
  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    border: 'none',
    boxShadow: 'none',
  },
  content: {
    padding: 0,
    '&:first-child': {
        paddingTop: 0,
    },
  },
  tagsContainer: {
    padding: theme.spacing(1),
    paddingBottom: 0,
    marginTop: theme.spacing(1),
  },
}));

const TicketPreviewModal = ({ open, onClose, ticket: initialTicket }) => {
  const classes = useStyles();
  const [ticket, setTicket] = useState(null);
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (initialTicket) {
      setTicket(initialTicket);
      setContact(initialTicket.contact);
      setLoading(false);
    } else {
        setTicket(null);
        setContact(null);
        setLoading(true);
    }
  }, [initialTicket]);
  
  useEffect(() => {
    if (!open || !ticket) return;

    const handleTicket = (data) => {
      if (data.action === "update" && data.ticket.id === ticket.id) {
        setTicket(data.ticket);
      }
    };

    const handleContact = (data) => {
      if (data.action === "update" && contact && data.contact.id === contact.id) {
        setContact(data.contact);
      }
    };

    const handleAppMessage = (data) => {
        if (data.action === "create" && data.ticket.id === ticket.id) {
            setTicket(prev => ({...prev, lastMessage: data.message.body}));
        }
    };

    socket.on("ticket", handleTicket);
    socket.on("contact", handleContact);
    socket.on("appMessage", handleAppMessage);

    return () => {
      socket.off("ticket", handleTicket);
      socket.off("contact", handleContact);
      socket.off("appMessage", handleAppMessage);
    };
  }, [open, ticket, contact]);


  if (loading || !ticket) {
    return (
        <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialogPaper }} maxWidth="md" fullWidth>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress />
            </Box>
        </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialogPaper }} maxWidth="md" fullWidth>
      <DialogContent dividers className={classes.content}>
        <div style={{ height: '100%' }}>
          <Paper variant="outlined" elevation={0} className={classes.mainWrapper}>
            <TicketHeader loading={false} onBack={onClose}>
              <TicketInfo contact={contact} ticket={ticket} />
            </TicketHeader>
            {contact?.id && (
              <Box className={classes.tagsContainer}>
                <TagSelect contactId={contact.id} />
              </Box>
            )}
            <ReplyMessageProvider>
              <MessagesList
                ticketId={ticket.id.toString()}
                isGroup={ticket.isGroup}
                isPreview={true}
              />
            </ReplyMessageProvider>
          </Paper>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cerrar previsualización
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketPreviewModal;
